import 'bootstrap/dist/css/bootstrap.css'
import 'dripicons/webfont/webfont.css'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
//  for element 1.9.9 below
// import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'material-design-icons/iconfont/material-icons.css'
import VCharts from 'v-charts'
import Vue from 'vue'
import VueAnimateNumber from 'vue-animate-number'
import vueEventCalendar from 'vue-event-calendar'
import VueGmaps from 'vue-gmaps'
import Resource from 'vue-resource'
import VueRouter from 'vue-router'
import Bars from 'vuebars'
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css'
import Vuelidate from 'vuelidate'
import {
  Avatar
} from 'vue-avatar'
import {
  VueTyper
} from 'vue-typer'
// Import top level component
import App from './App.vue'
import routerFabric from './routes'
import state from './state/index'
import Vuex from 'vuex'
Vue.use(Vuelidate)
// Resource logic
Vue.use(Resource)
Vue.http.options.emulateJSON = true

Vue.use(VueRouter)
Vue.use(ElementUI, {
  locale
})
Vue.use(Bars)
Vue.use(vueEventCalendar, {
  locale: 'en'
})
Vue.use(VueAnimateNumber)
Vue.use(VueGmaps, {
  key: 'AIzaSyCpr35b_ZSoP8nbz0VnBjVz6ABb7iurRCU',
  libraries: ['places'],
  version: '3'
})
Vue.use(VueLayers)
Vue.use(VCharts)
Vue.component('avatar', Avatar)
Vue.component('vue-typer', VueTyper)
Vue.use(Vuex)
const store = new Vuex.Store(state)
const router = routerFabric(store)
// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => h(App)
})

require('bootstrap')
// require('admin-lte')
require('../node_modules/admin-lte/dist/js/app.min.js')
require('../node_modules/admin-lte/dist/js/demo.js')
require('../node_modules/admin-lte/plugins/slimScroll/jquery.slimscroll.js')



// WEBPACK FOOTER //
// ./src/main.js